import { instanceApi } from '../../services';

export const getTranslations = (): Promise<any> => instanceApi.get(`api/settings/gettranslations`);
export const getTheme = (): Promise<any> => instanceApi.get('api/settings/gettheme');

export const getThemeByBrokerId = (brokerId: string): Promise<any> => instanceApi.get(`api/settings/getthemebybrokerid?brokerId=${brokerId}`);

export const clearThemeCache = (): Promise<any> => instanceApi.post('api/settings/clearthemescache');

export const getBalance = (currency: string): Promise<any> => instanceApi.get(`/api/balance?currency=${currency}`);
